import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StandardOkDialog } from "../../../view/dialogs/Poker2StandardOkDialog";
import { Poker2Command } from "../Poker2Command";

export class LCPCommand extends Poker2Command {
    protected get cmdId(): string {
        return "lcp";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            this.controller.dispatchEvent(new Poker2UserEvent("changePasswordComplete"));
            this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"),
                Poker2Model.languageData.getTextById("generic_change_password_error_success")));
            return true;
        }
        else
            this.controller.dispatchEvent(new Poker2UserEvent("changePasswordFaild"));
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
